import { useId } from "react";

export function DepositIcon({ className }: { className?: string }) {
  const id = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
      className={className}
    >
      <path
        fill="#fff"
        fillOpacity=".2"
        d="M0 14q0-1.704.059-3.365C.26 4.898 4.899.26 10.635.059Q12.297-.001 14 0q1.704 0 3.365.059c5.737.202 10.374 4.84 10.577 10.576Q28 12.297 28 13.999q0 1.704-.058 3.365c-.203 5.738-4.84 10.375-10.579 10.578Q15.702 28 14 28q-1.703 0-3.365-.058C4.898 27.739.26 23.102.06 17.364Q0 15.702 0 13.999m8.553 5.879c.541.5 1.387.47 1.887-.073l7.151-7.717.472 4.613c.035.336.191.631.422.844a1.334 1.334 0 0 0 2.236-1.116l-.733-7.124a1.67 1.67 0 0 0-.54-1.186c-.332-.308-.766-.467-1.129-.448l-7.254-.187a1.335 1.335 0 1 0-.07 2.67l4.637.117L8.48 17.99a1.337 1.337 0 0 0 .072 1.889"
      />
      <path
        fill={`url(#${id})`}
        fillOpacity=".3"
        d="M0 14q0-1.704.059-3.365C.26 4.898 4.899.26 10.635.059Q12.297-.001 14 0q1.704 0 3.365.059c5.737.202 10.374 4.84 10.577 10.576Q28 12.297 28 13.999q0 1.704-.058 3.365c-.203 5.738-4.84 10.375-10.579 10.578Q15.702 28 14 28q-1.703 0-3.365-.058C4.898 27.739.26 23.102.06 17.364Q0 15.702 0 13.999m8.553 5.879c.541.5 1.387.47 1.887-.073l7.151-7.717.472 4.613c.035.336.191.631.422.844a1.334 1.334 0 0 0 2.236-1.116l-.733-7.124a1.67 1.67 0 0 0-.54-1.186c-.332-.308-.766-.467-1.129-.448l-7.254-.187a1.335 1.335 0 1 0-.07 2.67l4.637.117L8.48 17.99a1.337 1.337 0 0 0 .072 1.889"
      />

      <defs>
        <linearGradient id={id} x1="0" x2="28" y1="0" y2="28" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".2" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <clipPath id="a" transform="translate(4 4)">
          <path d="M0 14q0-1.704.059-3.365C.26 4.898 4.899.26 10.635.059Q12.297-.001 14 0q1.704 0 3.365.059c5.737.202 10.374 4.84 10.577 10.576Q28 12.297 28 13.999q0 1.704-.058 3.365c-.203 5.738-4.84 10.375-10.579 10.578Q15.702 28 14 28q-1.703 0-3.365-.058C4.898 27.739.26 23.102.06 17.364Q0 15.702 0 13.999m8.553 5.879c.541.5 1.387.47 1.887-.073l7.151-7.717.472 4.613c.035.336.191.631.422.844a1.334 1.334 0 0 0 2.236-1.116l-.733-7.124a1.67 1.67 0 0 0-.54-1.186c-.332-.308-.766-.467-1.129-.448l-7.254-.187a1.335 1.335 0 1 0-.07 2.67l4.637.117L8.48 17.99a1.337 1.337 0 0 0 .072 1.889" />
        </clipPath>
      </defs>
    </svg>
  );
}
